import { IpRestrictionTranslator } from 'src/translators'
import { UpsertAllowedIpFormEntity } from 'src/types'
import {
  useUpdateIpRestrictionMutation,
  useCreateAllowedIpMutation,
  useUpdateAllowedIpMutation,
  useDeleteAllowedIpMutation,
} from 'src/types/generated'

type CreateAllowedIpInput = {
  formEntity: UpsertAllowedIpFormEntity
}
type UpdateAllowedIpInput = {
  allowedIpId: number
  formEntity: UpsertAllowedIpFormEntity
}
type DeleteAllowedIpInput = {
  allowedIpId: number
}

export const useIpRestriction = () => {
  const [updateIpRestrictionMutation] = useUpdateIpRestrictionMutation()
  const [createAllowedIpMutation] = useCreateAllowedIpMutation()
  const [updateAllowedIpMutation] = useUpdateAllowedIpMutation()
  const [deleteAllowedIpMutation] = useDeleteAllowedIpMutation()

  const updateIpRestriction = async (updatedIsIpRestricted: boolean): Promise<void> => {
    const input = IpRestrictionTranslator.toUpdateIpRestrictionRequest(updatedIsIpRestricted)
    await updateIpRestrictionMutation({ variables: { input } })
  }

  const createAllowedIp = async ({ formEntity }: CreateAllowedIpInput): Promise<void> => {
    const input = IpRestrictionTranslator.toUpsertAllowedIpRequest(formEntity)
    await createAllowedIpMutation({ variables: { input } })
  }

  const updateAllowedIp = async ({
    allowedIpId,
    formEntity,
  }: UpdateAllowedIpInput): Promise<void> => {
    const input = IpRestrictionTranslator.toUpsertAllowedIpRequest(formEntity)
    await updateAllowedIpMutation({ variables: { id: allowedIpId, input } })
  }

  const deleteAllowedIp = async ({ allowedIpId }: DeleteAllowedIpInput): Promise<void> => {
    await deleteAllowedIpMutation({ variables: { input: allowedIpId } })
  }

  return {
    updateIpRestriction,
    createAllowedIp,
    updateAllowedIp,
    deleteAllowedIp,
  }
}
